import { useEffect } from 'react'
import { Stack } from '@mui/material'

import DateRangeFilter from './DateRangeFilter'
import { fetchContributions } from 'redux/thunks/TextAnalysis'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import AddOrRemoveFilter from './AddOrRemoveFilter'

const TextAnalysisFilters = () => {
  const dispatch = useAppDispatch()
  const { hasUserFiltersUpdated } = useAppSelector(
    (state) => state.textAnalysis,
  )

  useEffect(() => {
    if (hasUserFiltersUpdated) dispatch(fetchContributions())
  }, [hasUserFiltersUpdated, dispatch])

  return (
    <Stack
      spacing={2}
      width="100%"
      data-testid="ta-filters"
      direction={{ xs: 'column', md: 'row' }}
    >
      <DateRangeFilter />
      <AddOrRemoveFilter />
    </Stack>
  )
}

export default TextAnalysisFilters
